var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );
dependencies["help-navigation/section-header-li.j2"] = require( "help-navigation/section-header-li.j2" );
dependencies["help-navigation/section-subitem.j2"] = require( "help-navigation/section-subitem.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/help-navigation/section-subitem.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/navigation-items.j2", false, "help/templates/help-navigation/section-subitem.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderNavItem")) {
var t_4 = t_1.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_4);
output += "\n\n";
output += runtime.suppressValue((lineno = 3, colno = 49, runtime.callWrap(t_4, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "sectionItemNavItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_5 = runtime.makeMacro(
["navItemToRender", "url", "target"], 
[], 
function (l_navItemToRender, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItemToRender", l_navItemToRender);
frame.set("url", l_url);
frame.set("target", l_target);
var t_6 = "";t_6 += "\n\n    ";
var t_7;
t_7 = runtime.memberLookup((l_navItemToRender),"typeCode");
frame.set("navType", t_7, true);
if(frame.topLevel) {
context.setVariable("navType", t_7);
}
if(frame.topLevel) {
context.addExport("navType", t_7);
}
t_6 += "\n    ";
var t_8;
t_8 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"slug") == runtime.memberLookup((l_navItemToRender),"slug")?" o-secondary-navigation__a--current":"");
frame.set("helpSelectedClass", t_8, true);
if(frame.topLevel) {
context.setVariable("helpSelectedClass", t_8);
}
if(frame.topLevel) {
context.addExport("helpSelectedClass", t_8);
}
t_6 += "\n    ";
var t_9;
t_9 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + l_url));
frame.set("subItemCanonicalUrl", t_9, true);
if(frame.topLevel) {
context.setVariable("subItemCanonicalUrl", t_9);
}
if(frame.topLevel) {
context.addExport("subItemCanonicalUrl", t_9);
}
t_6 += "\n    ";
var t_10;
t_10 = "noopener noreferrer";
frame.set("rel", t_10, true);
if(frame.topLevel) {
context.setVariable("rel", t_10);
}
if(frame.topLevel) {
context.addExport("rel", t_10);
}
t_6 += "\n\n    ";
if(l_navItemToRender) {
t_6 += "\n\n        <li class=\"o-secondary-navigation__li ";
t_6 += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_mobile") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")?"o-secondary-navigation__li--accordion o-accordion__tabset js-accordion-tabset is-collapsed":""), env.opts.autoescape);
t_6 += "\">\n\n            ";
if(runtime.memberLookup((l_navItemToRender),"slug") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"navRootSlug") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
t_6 += "\n\n                ";
t_6 += "\n                <a class=\"o-secondary-navigation__a js-secondary-navigation__a";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "helpSelectedClass"), env.opts.autoescape);
t_6 += "\" ";
if(l_target) {
t_6 += " target=\"";
t_6 += runtime.suppressValue(l_target, env.opts.autoescape);
t_6 += "\" ";
if(l_target == "_blank") {
t_6 += " rel=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_6 += "\" ";
;
}
t_6 += " ";
;
}
t_6 += " href=\"";
t_6 += runtime.suppressValue(l_url, env.opts.autoescape);
t_6 += "\">";
t_6 += runtime.suppressValue((lineno = 17, colno = 196, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["help_nav-back-to-parent",runtime.makeKeywordArgs({"params": [runtime.memberLookup((l_navItemToRender),"displayName")]})])), env.opts.autoescape);
t_6 += "</a>\n\n            ";
;
}
else {
if(runtime.memberLookup((l_navItemToRender),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((l_navItemToRender),"childSlugs")) > 0) {
t_6 += "\n\n                ";
var t_11;
t_11 = l_navItemToRender;
frame.set("sectionHeaderNavItem", t_11, true);
if(frame.topLevel) {
context.setVariable("sectionHeaderNavItem", t_11);
}
if(frame.topLevel) {
context.addExport("sectionHeaderNavItem", t_11);
}
t_6 += "\n\n                ";
env.getTemplate("help-navigation/section-header-li.j2", false, "help/templates/help-navigation/section-subitem.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_6 += t_13
t_6 += "\n\n                ";
t_6 += "\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_mobile") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
t_6 += "\n\n                <div id=\"o-accordion__panel--1\" class=\"o-accordion__panel js-accordion-panel\" aria-labelledby=\"o-accordion__tab--1\" aria-hidden=\"false\" role=\"tabpanel\">\n\n                    <ul class=\"o-secondary-navigation__ul o-secondary-navigation__ul--nested\" >\n\n                        ";
frame = frame.push();
var t_18 = runtime.memberLookup((l_navItemToRender),"childSlugs");
if(t_18) {var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("childSlug", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
t_6 += "\n\n                            ";
var t_20;
t_20 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_19);
frame.set("sectionItemNavItem", t_20, true);
if(frame.topLevel) {
context.setVariable("sectionItemNavItem", t_20);
}
if(frame.topLevel) {
context.addExport("sectionItemNavItem", t_20);
}
t_6 += "\n\n                            ";
env.getTemplate("help-navigation/section-subitem.j2", false, "help/templates/help-navigation/section-subitem.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_6 += t_22
t_6 += "\n\n                        ";
})});
}
}
frame = frame.pop();
t_6 += "\n\n                    </ul>\n\n                </div>\n\n                ";
t_6 += "\n                ";
;
}
else {
t_6 += "\n\n                <ul class=\"o-secondary-navigation__ul o-secondary-navigation__ul--nested\" itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\">\n\n                    ";
if(runtime.memberLookup((l_navItemToRender),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((l_navItemToRender),"childSlugs"))) {
t_6 += "\n                        <meta itemprop=\"name\" content=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((l_navItemToRender),"displayName"), env.opts.autoescape);
t_6 += "\" />\n                        <meta itemprop=\"url\" content=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "subItemCanonicalUrl"), env.opts.autoescape);
t_6 += "\" />\n                    ";
;
}
t_6 += "\n\n                    ";
frame = frame.push();
var t_27 = runtime.memberLookup((l_navItemToRender),"childSlugs");
if(t_27) {var t_26 = t_27.length;
for(var t_25=0; t_25 < t_27.length; t_25++) {
var t_28 = t_27[t_25];
frame.set("childSlug", t_28);
frame.set("loop.index", t_25 + 1);
frame.set("loop.index0", t_25);
frame.set("loop.revindex", t_26 - t_25);
frame.set("loop.revindex0", t_26 - t_25 - 1);
frame.set("loop.first", t_25 === 0);
frame.set("loop.last", t_25 === t_26 - 1);
frame.set("loop.length", t_26);
t_6 += "\n\n                        ";
var t_29;
t_29 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_28);
frame.set("sectionItemNavItem", t_29, true);
if(frame.topLevel) {
context.setVariable("sectionItemNavItem", t_29);
}
if(frame.topLevel) {
context.addExport("sectionItemNavItem", t_29);
}
t_6 += "\n\n                        <meta itemprop=\"name\" content=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sectionItemNavItem")),"displayName"), env.opts.autoescape);
t_6 += "\" />\n\n                        ";
env.getTemplate("help-navigation/section-subitem.j2", false, "help/templates/help-navigation/section-subitem.j2", null, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
t_30.render(context.getVariables(), frame, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_6 += t_31
t_6 += "\n\n                    ";
})});
}
}
frame = frame.pop();
t_6 += "\n\n                </ul>\n\n                ";
;
}
t_6 += "\n\n            ";
})});
}
else {
t_6 += "\n                ";
var t_34;
t_34 = (runtime.memberLookup((l_navItemToRender),"nestLevel")?"o-secondary-navigation__a--level-" + "" + runtime.memberLookup((l_navItemToRender),"nestLevel"):"");
frame.set("levelClass", t_34, true);
if(frame.topLevel) {
context.setVariable("levelClass", t_34);
}
if(frame.topLevel) {
context.addExport("levelClass", t_34);
}
t_6 += "\n                \n                ";
if(!runtime.memberLookup((l_navItemToRender),"childSlugs") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.contextOrFrameLookup(context, frame, "childSlug"))) {
t_6 += "\n                    <span itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\">\n                        <meta itemprop=\"name\" content=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((l_navItemToRender),"displayName"), env.opts.autoescape);
t_6 += "\" />\n                        <meta itemprop=\"url\" content=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "subItemCanonicalUrl"), env.opts.autoescape);
t_6 += "\" />\n                    </span>\n                ";
;
}
t_6 += "\n\n                <meta itemprop=\"url\" content=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "subItemCanonicalUrl"), env.opts.autoescape);
t_6 += "\" />\n                <a class=\"o-secondary-navigation__a js-secondary-navigation__a";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "helpSelectedClass"), env.opts.autoescape);
t_6 += " ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "levelClass"), env.opts.autoescape);
t_6 += "\" ";
if(l_target) {
t_6 += " target=\"";
t_6 += runtime.suppressValue(l_target, env.opts.autoescape);
t_6 += "\" ";
if(l_target == "_blank") {
t_6 += " rel=\"";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_6 += "\" ";
;
}
t_6 += " ";
;
}
t_6 += " href=\"";
t_6 += runtime.suppressValue(l_url, env.opts.autoescape);
t_6 += "\" data-qa-help-secondary-nav-item=\"";
t_6 += runtime.suppressValue(runtime.memberLookup((l_navItemToRender),"displayName"), env.opts.autoescape);
t_6 += "\">";
t_6 += runtime.suppressValue(runtime.memberLookup((l_navItemToRender),"displayName"), env.opts.autoescape);
t_6 += "</a>\n            ";
;
}
;
}
t_6 += "\n\n        </li>\n\n    ";
;
}
t_6 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_6);
});
return macro_t_5;})()})])), env.opts.autoescape);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/help-navigation/section-subitem.j2"] , dependencies)